import React from "react";

export default function CommaSeparator(value: number) {
  const formattedNumber = new Intl.NumberFormat().format(value);
  return formattedNumber;
}
